"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.default = exports.HeroFullWidthCompact = void 0;
require("./HeroFullWidthCompact.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _actionFormatter = require("../../util/actionFormatter/actionFormatter");
var _conditionalAttributes = require("../../util/conditionalAttributes/conditionalAttributes");
var _getButtonHtml = require("../../util/getButtonHtml/getButtonHtml");
var _getLinkHtml = require("../../util/getLinkHtml/getLinkHtml");
var _renderObject = require("../../util/renderObject/renderObject");
var _GridContainer = _interopRequireDefault(require("../GridContainer/GridContainer"));
var _HeroBody = _interopRequireDefault(require("../HeroBody/HeroBody"));
var _HeroFooter = _interopRequireDefault(require("../HeroFooter/HeroFooter"));
var _HeroHeader = _interopRequireDefault(require("../HeroHeader/HeroHeader"));
var _LoaderGhostCard = _interopRequireDefault(require("../LoaderGhostCard/LoaderGhostCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Represents a HeroFullWidthCompact component
 *
 * @method
 * @param {HeroFullWidthCompactProps} props
 * @returns HeroFullWidthCompact
 */

const HeroFullWidthCompact = props => {
  const {
    actionGroups,
    body,
    bodySecondLine,
    externalAction,
    externalActionFullyClick,
    externalMedia,
    eyebrow,
    footerStyle,
    fullyClickableParent,
    headline,
    headlineTag = defaultProps.headlineTag,
    image,
    tag,
    textColor = defaultProps.textColor,
    textPosition = defaultProps.textPosition,
    /* loading state props */
    isLoading = defaultProps.isLoading,
    loaderHeightXl,
    loaderHeightLg,
    loaderHeightMd,
    loaderHeightSm
  } = props;
  let formattedActionFullyClick;
  const textAlignment = textPosition === 'center-center' || textPosition === 'top-center' || textPosition === 'bottom-center' ? 'center' : 'left';
  const hasText = body || eyebrow || headline || actionGroups || tag;
  const hasImage = image || externalMedia;
  const isKnockoutLink = textColor === 'content-knockout';
  const paletteOneAction = actionGroups && actionGroups.actions?.length === 1;
  const hasOneAction = fullyClickableParent || paletteOneAction;
  if (paletteOneAction) {
    formattedActionFullyClick = (0, _actionFormatter.actionFormatter)({
      action: actionGroups?.actions[0],
      types: actionGroups?.types,
      hasOneAction: hasOneAction,
      derivedAriaLabel: actionGroups?.actions[0].label,
      fullyClickableParent: paletteOneAction
    }, {
      getButtonMarkup: _getButtonHtml.getButtonHtml,
      getLinkMarkup: _getLinkHtml.getLinkHtml
    });
  }
  const componentClassNameMain = (0, _classnames.default)('pal-c-HeroFullWidthCompact__mainContainer', {
    [`pal-c-HeroFullWidthCompact__contentAlign--${textPosition}`]: textPosition
  });
  const componentClassName = (0, _classnames.default)('pal-c-HeroFullWidthCompact', {
    [`pal-c-HeroFullWidthCompact--oneAction`]: hasOneAction
  });
  const containerStyle = {
    ...(0, _conditionalAttributes.conditionalAttributes)(isLoading ? {
      '--pal-loaderghost-card-height-xl': loaderHeightXl,
      '--pal-loaderghost-card-height-lg': loaderHeightLg,
      '--pal-loaderghost-card-height-md': loaderHeightMd,
      '--pal-loaderghost-card-height-sm': loaderHeightSm
    } : null)
  };
  const heroContent = () => {
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement(_LoaderGhostCard.default, {
        className: "pal-c-HeroFullWidthCompact__loader",
        variant: "default"
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasOneAction && /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroFullWidthCompact__fullyClickableParent"
      }, formattedActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(formattedActionFullyClick)), externalActionFullyClick && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalActionFullyClick))), hasImage && /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroFullWidthCompact__image"
      }, /*#__PURE__*/_react.default.createElement(_HeroHeader.default, {
        externalMedia: externalMedia,
        image: {
          desktopImage: image?.image,
          tabletImage: image?.tabletImage,
          mobileImage: image?.mobileImage,
          url: image?.url,
          ratio: image?.ratio,
          altText: image?.altText,
          loading: image?.loading
        }
      }))), hasText && /*#__PURE__*/_react.default.createElement("div", {
        className: componentClassNameMain
      }, /*#__PURE__*/_react.default.createElement(_GridContainer.default, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "pal-c-HeroFullWidthCompact__bodyAndAction"
      }, /*#__PURE__*/_react.default.createElement(_HeroBody.default, {
        tag: tag,
        eyebrow: eyebrow,
        headline: headline,
        headlineTag: headlineTag,
        headlineStyle: "display-sm",
        body: body,
        bodyStyle: "body-xlg",
        bodySecondLine: bodySecondLine,
        textAlign: textAlignment,
        textPosition: textAlignment,
        textColor: textColor
      }), /*#__PURE__*/_react.default.createElement(_HeroFooter.default, _extends({}, actionGroups, {
        alignment: textAlignment,
        externalAction: externalAction,
        isKnockoutLink: isKnockoutLink,
        style: footerStyle
      }))))));
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: containerStyle,
    className: componentClassName
  }, heroContent());
};

/**
 * Property type definitions
 * @typedef HeroFullWidthCompactProps
 * @type {object}
 * @property {object} actionGroups - Allows passing an object to the actionGroup prop
 * @property {string} body - body text/description of the hero body
 * @property {object} externalAction - external action object
 * @property {object} externalImage - brings in the UltaAsset
 * @property {string} eyebrow - smaller text above the headline
 * @property {string} footerStyle - style for footer
 * @property {string} headline - headline text of the hero body
 * @property {string} headlineTag - headline tag of the hero body
 * @property {object} image - desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
 * @property {object} primaryAction - Allows passing an object to the primaryAction prop
 * @property {object} tag - tag component above the eyebrow
 * @property {string} textColor - sets the color of the text to default or knockout
 * @property {string} textPosition - aligns the content to left or center
 * @property {boolean} isLoading - sets the loading state of the hero
 * @property {string} loaderHeightSm - Accepts the height of the loader for small viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightMd - Accepts the height of the loader for medium viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightLg - Accepts the height of the loader for large viewport( e.g. "32.2rem" )
 * @property {string} loaderHeightXl - Accepts the height of the loader for xLarge viewport( e.g. "32.2rem" )
 */
exports.HeroFullWidthCompact = HeroFullWidthCompact;
const propTypes = {
  /**
   * Allows passing an object to the actionGroups prop
   */
  actionGroups: _propTypes.default.object,
  /**
   * body text/description of the hero body
   */
  body: _propTypes.default.string,
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /**
   * Brings in the UltaAsset
   */
  externalImage: _propTypes.default.object,
  /**
   * Smaller text above the headline
   */
  eyebrow: _propTypes.default.string,
  /**
   * style for footer
   */
  footerStyle: _propTypes.default.string,
  /**
   * headline text of the hero body
   */
  headline: _propTypes.default.string,
  /**
   * HTML tag for the headline
   */
  headlineTag: _propTypes.default.string,
  /**
   * desktopImage, tabletImage, mobileImage, type, altText, ratio and loading prop for Image component
   */
  image: _propTypes.default.object,
  /**
   * Allows passing an object to the primaryAction prop
   */
  primaryAction: _propTypes.default.object,
  /**
   * tag component above the eyebrow
   */
  tag: _propTypes.default.object,
  /**
   * Sets the color of the text to default or knockout
   */
  textColor: _propTypes.default.oneOf(['content-default', 'content-knockout']),
  /**
   * Aligns the content to left or center
   */
  textPosition: _propTypes.default.oneOf(['top-center', 'top-left', 'center-center', 'center-left', 'bottom-center', 'bottom-left']),
  /**
   * Sets the loading state of the hero
   */
  isLoading: _propTypes.default.bool,
  /**
   * Accepts the height of the loader for small viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightSm: _propTypes.default.string,
  /**
   * Accepts the height of the loader for medium viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightMd: _propTypes.default.string,
  /**
   * Accepts the height of the loader for large viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightLg: _propTypes.default.string,
  /**
   * Accepts the height of the loader for Xlarge viewport.
   * Expect a CSS length string (for example: **"32.2rem"**)
   */
  loaderHeightXl: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} headlineTag - headlineTag: 'h2' - sets the default for the headline tag
 * @property {string} textColor - textColor: 'content-default'- sets the color of the text to content-default or content-knockout
 * @property {string} textPosition - textPosition: 'center-left' - aligns the content to left or center
 * @property {boolean} isLoading - isLoading: false - sets the default loading state to false
 */
const defaultProps = exports.defaultProps = {
  headlineTag: 'h2',
  textColor: 'content-default',
  textPosition: 'center-left',
  isLoading: false
};
HeroFullWidthCompact.propTypes = propTypes;
var _default = exports.default = HeroFullWidthCompact;